var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyMessages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.8693 8.94531H7.54026C3.37565 8.94531 0 12.321 0 16.4856C0 20.6502 3.37565 24.0258 7.54026 24.0258H7.79111V31.024C7.79111 31.144 7.93677 31.2047 8.02173 31.1197L15.1142 24.0272H42.8693C47.0339 24.0272 50.4096 20.6515 50.4096 16.4869C50.4096 12.3223 47.0339 8.94531 42.8693 8.94531Z",
    fill: "#2B71F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7496 51.0547H53.448C57.0668 51.0547 60 48.1215 60 44.5027C60 40.884 57.0668 37.9508 53.448 37.9508H32.2301V31.8699C32.2301 31.7656 32.1035 31.7129 32.0297 31.7867L25.8668 37.9496H22.7496C19.1309 37.9496 16.1977 40.8828 16.1977 44.5016C16.1977 48.1203 19.1309 51.0547 22.7496 51.0547Z",
    fill: "#4FB5F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyMessages);
export default __webpack_public_path__ + "static/media/my-messages.809cc6c294924270a7f61be3ab68854c.svg";
export { ForwardRef as ReactComponent };